import { Relationships } from '@leverege/ui-attributes';
import { matchPath } from 'react-router';
import OpenApiGroupDelegate from "../delegates/openApi/OpenApiGroupDelegate.js";
import OpenApiItemDelegate from "../delegates/openApi/OpenApiItemDelegate.js";
import OpenApiRelationship from "../relationship/OpenApiRelationship.js";
let lastRel = null;
let relationships = [];
export default class OpenApiDataSource {
  constructor(opts) {
    this.opts = opts ?? {};
    const {
      type
    } = this.opts.bp;
    this.type = type;
  }
  dataSource() {
    return this.type;
  }
  getData(objRef) {
    return this.getActions(objRef)?.getItem();
  }
  getActions(objRef) {
    const rel = OpenApiDataSource.getRelationship(objRef);
    if (rel != null) {
      // rel is { match, relationship }
      return new OpenApiItemDelegate({
        item: objRef,
        id: objRef?.id,
        match: rel.match,
        relationship: rel.relationship.createResolved(rel.match)
      });
    }
    return null;
  }

  /**
   * Returns { relationship, match } for the given objectRef. Rel will be the
   * relationship for the object, and match will be the extracted
   * ids of the parents. This will return null if there is not a matching
   * relationship
   */
  static getRelationship(objRef) {
    const {
      id,
      ref
    } = objRef;
    return getRelationshipFor(`${ref}/${id}`);
  }
}
function getRelationshipFor(ref) {
  if (lastRel !== Relationships.getAll()) {
    lastRel = Relationships.getAll();

    // rebuild relationships on a change
    relationships = lastRel.filter(rel => rel instanceof OpenApiRelationship).map(rel => {
      const r = rel.createItem();
      const match = {
        path: r.objRefUrlPath,
        exact: true,
        strict: true
      };
      return {
        match,
        relationship: r
      };
    });
    sort();
  }
  for (let n = 0; n < relationships.length; n++) {
    const rel = relationships[n];
    const match = matchPath(ref, rel.match);
    if (match) {
      return {
        match,
        relationship: rel.relationship
      };
    }
  }
  return null;
}
function sort() {
  relationships.sort((a, b) => {
    return a.relationship.objRefUrlPath.localeCompare(b.relationship.objRefUrlPath);
  });
}